import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import useIdentifySsoClient from "../../SSOClientsData/useIdentifySsoClient";
import { getClientThunk } from "../../redux/features/loginSlice";

const HomeSSORedirectDynamic = () => {
  const dispatch = useDispatch();
  const [coNu, setCoNu] = useState("");
  const envs = ["qa", "uat", "localhost", "dev"];
  const prodSsoLoginByEnv = envs.every(
    (e) => !window.location.host.includes(e)
  );

  useEffect(() => {
    dispatch(getClientThunk()).then((resp) =>{
      console.log(resp, "resp");
      setCoNu(resp?.payload?.companyNumber)
    }
    );
  }, []);

  let clientData;
  let loginRedirect = false;
  if (coNu) {
    clientData = useIdentifySsoClient(coNu);
    if (!clientData) loginRedirect = true;
    console.log(clientData, "url client");
  }

  if (clientData) {
    if (window.location.host.includes("uat") && clientData?.isSsoClient) {
      if (clientData?.ssoUatUrl) {
        window.location.replace(clientData?.ssoUatUrl);
      } else {
        window.location.replace(`https://${window.location.host}/login`);
      }
    } else if (prodSsoLoginByEnv && clientData?.isSsoClient) {
      if (clientData?.ssoProdUrl) {
        window.location.replace(clientData?.ssoProdUrl);
      } else {
        window.location.replace(`https://${window.location.host}/login`);
      }
    } else {
      if (window.location.host.includes("localhost")) {
        window.location.replace(`http://${window.location.host}/login`);
      } else {
        window.location.replace(`https://${window.location.host}/login`);
      }
    }
  } else if (loginRedirect) {
    if (window.location.host.includes("localhost")) {
      window.location.replace(`http://${window.location.host}/login`);
    } else {
      window.location.replace(`https://${window.location.host}/login`);
    }
  }

  return null;
};

export default HomeSSORedirectDynamic;
